var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "44px",
    viewBox: "0 0 32 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#181C4B",
    points: "0.00098 44 0.00098 0 32.00098 0 32.00098 44 16.50098 44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.002,19.5472 L16.0011,3.5463 L0,19.5472 C0,21.4532 0,22.5218 0,24.4279 L16.0009,40.4288 L32.002,24.4278 C32.002,22.5218 32.002,21.4532 32.002,19.5472",
    id: "Fill-4",
    fill: "#003AFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-28",
    fill: "#00FFC2",
    points: "21.273 11.42406 16.001 6.15206 10.729 11.42406 16.001 16.69606"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-30",
    fill: "#00FFC2",
    points: "21.273 21.98685 16.001 16.71485 10.729 21.98685 16.001 27.25885"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-32",
    fill: "#00FFC2",
    points: "21.273 32.57594 16.001 27.30394 10.729 32.57594 16.001 37.84794"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg04);
export default __webpack_public_path__ + "static/media/04.d6a573fa5e6eafee8c1b84165ad500f9.svg";
export { ForwardRef as ReactComponent };